import React from 'react';
import { Shield, Percent, Calendar as CalendarIcon, Headphones } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const WhyBookDirect = () => {
  const { t } = useLanguage();

  const benefits = [
    { icon: Shield, title: t('whyBookDirect.b1t'), description: t('whyBookDirect.b1d') },
    { icon: Percent, title: t('whyBookDirect.b2t'), description: t('whyBookDirect.b2d') },
    { icon: CalendarIcon, title: t('whyBookDirect.b3t'), description: t('whyBookDirect.b3d') },
    { icon: Headphones, title: t('whyBookDirect.b4t'), description: t('whyBookDirect.b4d') }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-[#1a1f2e] to-[#252b3d] text-white" data-testid="why-book-direct-section">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <p className="text-orange-400 font-semibold mb-2 text-sm uppercase tracking-wider">{t('whyBookDirect.eyebrow')}</p>
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">{t('whyBookDirect.heading')}</h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            {t('whyBookDirect.lead')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit) => {
            const Icon = benefit.icon;
            return (
              <div
                key={benefit.title}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/15 transition-all duration-300 hover:transform hover:scale-105 border border-white/10"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg flex items-center justify-center mb-4">
                  <Icon size={28} className="text-white" />
                </div>
                <h3 className="text-xl font-bold mb-2">{benefit.title}</h3>
                <p className="text-gray-300 text-sm leading-relaxed">{benefit.description}</p>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-10 py-4 rounded-full font-bold text-lg hover:from-orange-600 hover:to-orange-700 transition-all shadow-lg hover:shadow-xl inline-flex items-center gap-2"
            data-testid="why-book-direct-cta"
          >
            {t('whyBookDirect.cta')}
            <span className="text-2xl">→</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhyBookDirect;
